import { Component } from 'react';
import PropTypes from 'prop-types';

class WindowEventWatcher extends Component {

    componentDidMount() {
        this.mounted = true;
        const {listening, eventName} = this.props;
        if (listening && eventName) {
            window.addEventListener(eventName, this.eventTriggeredHandler);
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {listening, eventName} = this.props;
        if (!eventName) {
            return;
        }

        if (listening) {
            return window.addEventListener(eventName, this.eventTriggeredHandler);
        }

        window.removeEventListener(eventName, this.eventTriggeredHandler);
    }

    componentWillUnmount() {
        const {eventName} = this.props;
        window.removeEventListener(eventName, this.eventTriggeredHandler);
        this.mounted = false;
    }

    eventTriggeredHandler = (e, ...otherProps) => {
        if (this.mounted) {
            const {handlerFn} = this.props;
            handlerFn(e, otherProps);
        }
    };

    render() {
        const {children} = this.props;

        return children;
    }
}

WindowEventWatcher.propTypes = {
    children: PropTypes.any,
    handlerFn: PropTypes.func,
    eventName: PropTypes.string,
    listening: PropTypes.bool,
};

WindowEventWatcher.defaultProps = {
    children: null,
    handlerFn: () => null,
    eventName: null,
    listening: true
};

export default WindowEventWatcher;

